/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FeedbacksDto,
  GetUserDto,
  LastActiveTenant,
  RegisterUserDto,
  Settings,
  SubmitFeedbackDto,
  TenantSettings,
  UpdateSettingsDto,
  UpdateUserAttributesDto,
  UpdateUserDetailsDto,
  User,
  UserCountryAndPostalCode,
  UserEventDto,
  UserExists,
  UserFeedback,
} from '../models/index';
import {
    FeedbacksDtoFromJSON,
    FeedbacksDtoToJSON,
    GetUserDtoFromJSON,
    GetUserDtoToJSON,
    LastActiveTenantFromJSON,
    LastActiveTenantToJSON,
    RegisterUserDtoFromJSON,
    RegisterUserDtoToJSON,
    SettingsFromJSON,
    SettingsToJSON,
    SubmitFeedbackDtoFromJSON,
    SubmitFeedbackDtoToJSON,
    TenantSettingsFromJSON,
    TenantSettingsToJSON,
    UpdateSettingsDtoFromJSON,
    UpdateSettingsDtoToJSON,
    UpdateUserAttributesDtoFromJSON,
    UpdateUserAttributesDtoToJSON,
    UpdateUserDetailsDtoFromJSON,
    UpdateUserDetailsDtoToJSON,
    UserFromJSON,
    UserToJSON,
    UserCountryAndPostalCodeFromJSON,
    UserCountryAndPostalCodeToJSON,
    UserEventDtoFromJSON,
    UserEventDtoToJSON,
    UserExistsFromJSON,
    UserExistsToJSON,
    UserFeedbackFromJSON,
    UserFeedbackToJSON,
} from '../models/index';

export interface CreateUserRequest {
    mamaDisease: CreateUserMamaDiseaseEnum;
    mamaOrganisation?: CreateUserMamaOrganisationEnum;
}

export interface GetDynamicManifestRequest {
    disease: string;
}

export interface GetMeRequest {
    mamaDisease: GetMeMamaDiseaseEnum;
    mamaOrganisation?: GetMeMamaOrganisationEnum;
}

export interface GetTenantSettingsRequest {
    mamaDisease: GetTenantSettingsMamaDiseaseEnum;
    mamaOrganisation?: GetTenantSettingsMamaOrganisationEnum;
}

export interface GetUserRequest {
    mamaDisease: GetUserMamaDiseaseEnum;
    getUserDto: GetUserDto;
    mamaOrganisation?: GetUserMamaOrganisationEnum;
}

export interface LogUserEventRequest {
    userEventDto: UserEventDto;
}

export interface MarkSignUpAsDoneRequest {
    mamaDisease: MarkSignUpAsDoneMamaDiseaseEnum;
    mamaOrganisation?: MarkSignUpAsDoneMamaOrganisationEnum;
}

export interface RegisterUserRequest {
    registerUserDto: RegisterUserDto;
}

export interface SetLastActiveTenantRequest {
    lastActiveTenant: LastActiveTenant;
}

export interface ShowFeedbackRequest {
    feedbacksDto: FeedbacksDto;
}

export interface SubmitUserFeedbackRequest {
    submitFeedbackDto: SubmitFeedbackDto;
}

export interface UpdateSettingsRequest {
    mamaDisease: UpdateSettingsMamaDiseaseEnum;
    updateSettingsDto: UpdateSettingsDto;
}

export interface UpdateUserAttributesRequest {
    mamaDisease: UpdateUserAttributesMamaDiseaseEnum;
    updateUserAttributesDto: UpdateUserAttributesDto;
    mamaOrganisation?: UpdateUserAttributesMamaOrganisationEnum;
}

export interface UpdateUserDetailsRequest {
    mamaDisease: UpdateUserDetailsMamaDiseaseEnum;
    updateUserDetailsDto: UpdateUserDetailsDto;
    mamaOrganisation?: UpdateUserDetailsMamaOrganisationEnum;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async aliveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alive`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async alive(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.aliveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async createUserRaw(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.mamaDisease === null || requestParameters.mamaDisease === undefined) {
            throw new runtime.RequiredError('mamaDisease','Required parameter requestParameters.mamaDisease was null or undefined when calling createUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.mamaDisease !== undefined && requestParameters.mamaDisease !== null) {
            headerParameters['mama-disease'] = String(requestParameters.mamaDisease);
        }

        if (requestParameters.mamaOrganisation !== undefined && requestParameters.mamaOrganisation !== null) {
            headerParameters['mama-organisation'] = String(requestParameters.mamaOrganisation);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-creation/create-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createUser(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deletUserFromCognitoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-deletion/delete-cognito-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletUserFromCognito(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletUserFromCognitoRaw(initOverrides);
    }

    /**
     */
    async deleteAllUserRecordsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-deletion/delete-all-records`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAllUserRecords(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAllUserRecordsRaw(initOverrides);
    }

    /**
     */
    async dismissUserFeedbackRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-feedback/dismiss-user-feedback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async dismissUserFeedback(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dismissUserFeedbackRaw(initOverrides);
    }

    /**
     */
    async getDynamicManifestRaw(requestParameters: GetDynamicManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.disease === null || requestParameters.disease === undefined) {
            throw new runtime.RequiredError('disease','Required parameter requestParameters.disease was null or undefined when calling getDynamicManifest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/tenant/{disease}/manifest.json`.replace(`{${"disease"}}`, encodeURIComponent(String(requestParameters.disease))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getDynamicManifest(requestParameters: GetDynamicManifestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getDynamicManifestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLastActiveTenantRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LastActiveTenant>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/last-active-tenant`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LastActiveTenantFromJSON(jsonValue));
    }

    /**
     */
    async getLastActiveTenant(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LastActiveTenant> {
        const response = await this.getLastActiveTenantRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMeRaw(requestParameters: GetMeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.mamaDisease === null || requestParameters.mamaDisease === undefined) {
            throw new runtime.RequiredError('mamaDisease','Required parameter requestParameters.mamaDisease was null or undefined when calling getMe.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.mamaDisease !== undefined && requestParameters.mamaDisease !== null) {
            headerParameters['mama-disease'] = String(requestParameters.mamaDisease);
        }

        if (requestParameters.mamaOrganisation !== undefined && requestParameters.mamaOrganisation !== null) {
            headerParameters['mama-organisation'] = String(requestParameters.mamaOrganisation);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     */
    async getMe(requestParameters: GetMeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getMeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantSettingsRaw(requestParameters: GetTenantSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSettings>> {
        if (requestParameters.mamaDisease === null || requestParameters.mamaDisease === undefined) {
            throw new runtime.RequiredError('mamaDisease','Required parameter requestParameters.mamaDisease was null or undefined when calling getTenantSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.mamaDisease !== undefined && requestParameters.mamaDisease !== null) {
            headerParameters['mama-disease'] = String(requestParameters.mamaDisease);
        }

        if (requestParameters.mamaOrganisation !== undefined && requestParameters.mamaOrganisation !== null) {
            headerParameters['mama-organisation'] = String(requestParameters.mamaOrganisation);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tenant/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantSettingsFromJSON(jsonValue));
    }

    /**
     */
    async getTenantSettings(requestParameters: GetTenantSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantSettings> {
        const response = await this.getTenantSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.mamaDisease === null || requestParameters.mamaDisease === undefined) {
            throw new runtime.RequiredError('mamaDisease','Required parameter requestParameters.mamaDisease was null or undefined when calling getUser.');
        }

        if (requestParameters.getUserDto === null || requestParameters.getUserDto === undefined) {
            throw new runtime.RequiredError('getUserDto','Required parameter requestParameters.getUserDto was null or undefined when calling getUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.mamaDisease !== undefined && requestParameters.mamaDisease !== null) {
            headerParameters['mama-disease'] = String(requestParameters.mamaDisease);
        }

        if (requestParameters.mamaOrganisation !== undefined && requestParameters.mamaOrganisation !== null) {
            headerParameters['mama-organisation'] = String(requestParameters.mamaOrganisation);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUserDtoToJSON(requestParameters.getUserDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserCountryAndPostalCodeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserCountryAndPostalCode>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/me/city-and-postalcode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserCountryAndPostalCodeFromJSON(jsonValue));
    }

    /**
     */
    async getUserCountryAndPostalCode(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserCountryAndPostalCode> {
        const response = await this.getUserCountryAndPostalCodeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async logUserEventRaw(requestParameters: LogUserEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userEventDto === null || requestParameters.userEventDto === undefined) {
            throw new runtime.RequiredError('userEventDto','Required parameter requestParameters.userEventDto was null or undefined when calling logUserEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-activity/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserEventDtoToJSON(requestParameters.userEventDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async logUserEvent(requestParameters: LogUserEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logUserEventRaw(requestParameters, initOverrides);
    }

    /**
     */
    async markSignUpAsDoneRaw(requestParameters: MarkSignUpAsDoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.mamaDisease === null || requestParameters.mamaDisease === undefined) {
            throw new runtime.RequiredError('mamaDisease','Required parameter requestParameters.mamaDisease was null or undefined when calling markSignUpAsDone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.mamaDisease !== undefined && requestParameters.mamaDisease !== null) {
            headerParameters['mama-disease'] = String(requestParameters.mamaDisease);
        }

        if (requestParameters.mamaOrganisation !== undefined && requestParameters.mamaOrganisation !== null) {
            headerParameters['mama-organisation'] = String(requestParameters.mamaOrganisation);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/signup/mark-as-done`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async markSignUpAsDone(requestParameters: MarkSignUpAsDoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markSignUpAsDoneRaw(requestParameters, initOverrides);
    }

    /**
     */
    async registerUserRaw(requestParameters: RegisterUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.registerUserDto === null || requestParameters.registerUserDto === undefined) {
            throw new runtime.RequiredError('registerUserDto','Required parameter requestParameters.registerUserDto was null or undefined when calling registerUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-creation/register-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterUserDtoToJSON(requestParameters.registerUserDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async registerUser(requestParameters: RegisterUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.registerUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async retrieveUnseenFeedbacksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserFeedback>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-feedback/retrieve-unseen-feedbacks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserFeedbackFromJSON));
    }

    /**
     */
    async retrieveUnseenFeedbacks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserFeedback>> {
        const response = await this.retrieveUnseenFeedbacksRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async setLastActiveTenantRaw(requestParameters: SetLastActiveTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.lastActiveTenant === null || requestParameters.lastActiveTenant === undefined) {
            throw new runtime.RequiredError('lastActiveTenant','Required parameter requestParameters.lastActiveTenant was null or undefined when calling setLastActiveTenant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/last-active-tenant`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LastActiveTenantToJSON(requestParameters.lastActiveTenant),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setLastActiveTenant(requestParameters: SetLastActiveTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setLastActiveTenantRaw(requestParameters, initOverrides);
    }

    /**
     */
    async showFeedbackRaw(requestParameters: ShowFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.feedbacksDto === null || requestParameters.feedbacksDto === undefined) {
            throw new runtime.RequiredError('feedbacksDto','Required parameter requestParameters.feedbacksDto was null or undefined when calling showFeedback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-feedback/show-feedback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FeedbacksDtoToJSON(requestParameters.feedbacksDto),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async showFeedback(requestParameters: ShowFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.showFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async submitUserFeedbackRaw(requestParameters: SubmitUserFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.submitFeedbackDto === null || requestParameters.submitFeedbackDto === undefined) {
            throw new runtime.RequiredError('submitFeedbackDto','Required parameter requestParameters.submitFeedbackDto was null or undefined when calling submitUserFeedback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-feedback/submit-feedback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitFeedbackDtoToJSON(requestParameters.submitFeedbackDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async submitUserFeedback(requestParameters: SubmitUserFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitUserFeedbackRaw(requestParameters, initOverrides);
    }

    /**
     */
    async unlinkTemporaryTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-creation/unlink-temporary-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async unlinkTemporaryToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkTemporaryTokenRaw(initOverrides);
    }

    /**
     */
    async updateSettingsRaw(requestParameters: UpdateSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Settings>> {
        if (requestParameters.mamaDisease === null || requestParameters.mamaDisease === undefined) {
            throw new runtime.RequiredError('mamaDisease','Required parameter requestParameters.mamaDisease was null or undefined when calling updateSettings.');
        }

        if (requestParameters.updateSettingsDto === null || requestParameters.updateSettingsDto === undefined) {
            throw new runtime.RequiredError('updateSettingsDto','Required parameter requestParameters.updateSettingsDto was null or undefined when calling updateSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.mamaDisease !== undefined && requestParameters.mamaDisease !== null) {
            headerParameters['mama-disease'] = String(requestParameters.mamaDisease);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/me/settings`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSettingsDtoToJSON(requestParameters.updateSettingsDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingsFromJSON(jsonValue));
    }

    /**
     */
    async updateSettings(requestParameters: UpdateSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Settings> {
        const response = await this.updateSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateUserAttributesRaw(requestParameters: UpdateUserAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateUserAttributesDto>> {
        if (requestParameters.mamaDisease === null || requestParameters.mamaDisease === undefined) {
            throw new runtime.RequiredError('mamaDisease','Required parameter requestParameters.mamaDisease was null or undefined when calling updateUserAttributes.');
        }

        if (requestParameters.updateUserAttributesDto === null || requestParameters.updateUserAttributesDto === undefined) {
            throw new runtime.RequiredError('updateUserAttributesDto','Required parameter requestParameters.updateUserAttributesDto was null or undefined when calling updateUserAttributes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.mamaDisease !== undefined && requestParameters.mamaDisease !== null) {
            headerParameters['mama-disease'] = String(requestParameters.mamaDisease);
        }

        if (requestParameters.mamaOrganisation !== undefined && requestParameters.mamaOrganisation !== null) {
            headerParameters['mama-organisation'] = String(requestParameters.mamaOrganisation);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attributes`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserAttributesDtoToJSON(requestParameters.updateUserAttributesDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUserAttributesDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateUserAttributes(requestParameters: UpdateUserAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateUserAttributesDto> {
        const response = await this.updateUserAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateUserDetailsRaw(requestParameters: UpdateUserDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.mamaDisease === null || requestParameters.mamaDisease === undefined) {
            throw new runtime.RequiredError('mamaDisease','Required parameter requestParameters.mamaDisease was null or undefined when calling updateUserDetails.');
        }

        if (requestParameters.updateUserDetailsDto === null || requestParameters.updateUserDetailsDto === undefined) {
            throw new runtime.RequiredError('updateUserDetailsDto','Required parameter requestParameters.updateUserDetailsDto was null or undefined when calling updateUserDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.mamaDisease !== undefined && requestParameters.mamaDisease !== null) {
            headerParameters['mama-disease'] = String(requestParameters.mamaDisease);
        }

        if (requestParameters.mamaOrganisation !== undefined && requestParameters.mamaOrganisation !== null) {
            headerParameters['mama-organisation'] = String(requestParameters.mamaOrganisation);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/details`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserDetailsDtoToJSON(requestParameters.updateUserDetailsDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateUserDetails(requestParameters: UpdateUserDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserDetailsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userExistsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserExists>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-creation/user-exists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserExistsFromJSON(jsonValue));
    }

    /**
     */
    async userExists(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserExists> {
        const response = await this.userExistsRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateUserMamaDiseaseEnum = {
    Opade: 'OPADE'
} as const;
export type CreateUserMamaDiseaseEnum = typeof CreateUserMamaDiseaseEnum[keyof typeof CreateUserMamaDiseaseEnum];
/**
 * @export
 */
export const CreateUserMamaOrganisationEnum = {
    Ailc: 'ailc',
    Dadi: 'dadi',
    Tanalentamente: 'tanalentamente',
    Dermatiteatopicadiary: 'dermatiteatopicadiary',
    MiasteniaItalia: 'miastenia-italia',
    Aendo: 'aendo',
    NoiConVoi: 'noi-con-voi',
    EndoCare: 'endo-care',
    Endometriosevereinigung: 'endometriosevereinigung'
} as const;
export type CreateUserMamaOrganisationEnum = typeof CreateUserMamaOrganisationEnum[keyof typeof CreateUserMamaOrganisationEnum];
/**
 * @export
 */
export const GetMeMamaDiseaseEnum = {
    Opade: 'OPADE'
} as const;
export type GetMeMamaDiseaseEnum = typeof GetMeMamaDiseaseEnum[keyof typeof GetMeMamaDiseaseEnum];
/**
 * @export
 */
export const GetMeMamaOrganisationEnum = {
    Ailc: 'ailc',
    Dadi: 'dadi',
    Tanalentamente: 'tanalentamente',
    Dermatiteatopicadiary: 'dermatiteatopicadiary',
    MiasteniaItalia: 'miastenia-italia',
    Aendo: 'aendo',
    NoiConVoi: 'noi-con-voi',
    EndoCare: 'endo-care',
    Endometriosevereinigung: 'endometriosevereinigung'
} as const;
export type GetMeMamaOrganisationEnum = typeof GetMeMamaOrganisationEnum[keyof typeof GetMeMamaOrganisationEnum];
/**
 * @export
 */
export const GetTenantSettingsMamaDiseaseEnum = {
    Opade: 'OPADE'
} as const;
export type GetTenantSettingsMamaDiseaseEnum = typeof GetTenantSettingsMamaDiseaseEnum[keyof typeof GetTenantSettingsMamaDiseaseEnum];
/**
 * @export
 */
export const GetTenantSettingsMamaOrganisationEnum = {
    Ailc: 'ailc',
    Dadi: 'dadi',
    Tanalentamente: 'tanalentamente',
    Dermatiteatopicadiary: 'dermatiteatopicadiary',
    MiasteniaItalia: 'miastenia-italia',
    Aendo: 'aendo',
    NoiConVoi: 'noi-con-voi',
    EndoCare: 'endo-care',
    Endometriosevereinigung: 'endometriosevereinigung'
} as const;
export type GetTenantSettingsMamaOrganisationEnum = typeof GetTenantSettingsMamaOrganisationEnum[keyof typeof GetTenantSettingsMamaOrganisationEnum];
/**
 * @export
 */
export const GetUserMamaDiseaseEnum = {
    Opade: 'OPADE'
} as const;
export type GetUserMamaDiseaseEnum = typeof GetUserMamaDiseaseEnum[keyof typeof GetUserMamaDiseaseEnum];
/**
 * @export
 */
export const GetUserMamaOrganisationEnum = {
    Ailc: 'ailc',
    Dadi: 'dadi',
    Tanalentamente: 'tanalentamente',
    Dermatiteatopicadiary: 'dermatiteatopicadiary',
    MiasteniaItalia: 'miastenia-italia',
    Aendo: 'aendo',
    NoiConVoi: 'noi-con-voi',
    EndoCare: 'endo-care',
    Endometriosevereinigung: 'endometriosevereinigung'
} as const;
export type GetUserMamaOrganisationEnum = typeof GetUserMamaOrganisationEnum[keyof typeof GetUserMamaOrganisationEnum];
/**
 * @export
 */
export const MarkSignUpAsDoneMamaDiseaseEnum = {
    Opade: 'OPADE'
} as const;
export type MarkSignUpAsDoneMamaDiseaseEnum = typeof MarkSignUpAsDoneMamaDiseaseEnum[keyof typeof MarkSignUpAsDoneMamaDiseaseEnum];
/**
 * @export
 */
export const MarkSignUpAsDoneMamaOrganisationEnum = {
    Ailc: 'ailc',
    Dadi: 'dadi',
    Tanalentamente: 'tanalentamente',
    Dermatiteatopicadiary: 'dermatiteatopicadiary',
    MiasteniaItalia: 'miastenia-italia',
    Aendo: 'aendo',
    NoiConVoi: 'noi-con-voi',
    EndoCare: 'endo-care',
    Endometriosevereinigung: 'endometriosevereinigung'
} as const;
export type MarkSignUpAsDoneMamaOrganisationEnum = typeof MarkSignUpAsDoneMamaOrganisationEnum[keyof typeof MarkSignUpAsDoneMamaOrganisationEnum];
/**
 * @export
 */
export const UpdateSettingsMamaDiseaseEnum = {
    Opade: 'OPADE'
} as const;
export type UpdateSettingsMamaDiseaseEnum = typeof UpdateSettingsMamaDiseaseEnum[keyof typeof UpdateSettingsMamaDiseaseEnum];
/**
 * @export
 */
export const UpdateUserAttributesMamaDiseaseEnum = {
    Opade: 'OPADE'
} as const;
export type UpdateUserAttributesMamaDiseaseEnum = typeof UpdateUserAttributesMamaDiseaseEnum[keyof typeof UpdateUserAttributesMamaDiseaseEnum];
/**
 * @export
 */
export const UpdateUserAttributesMamaOrganisationEnum = {
    Ailc: 'ailc',
    Dadi: 'dadi',
    Tanalentamente: 'tanalentamente',
    Dermatiteatopicadiary: 'dermatiteatopicadiary',
    MiasteniaItalia: 'miastenia-italia',
    Aendo: 'aendo',
    NoiConVoi: 'noi-con-voi',
    EndoCare: 'endo-care',
    Endometriosevereinigung: 'endometriosevereinigung'
} as const;
export type UpdateUserAttributesMamaOrganisationEnum = typeof UpdateUserAttributesMamaOrganisationEnum[keyof typeof UpdateUserAttributesMamaOrganisationEnum];
/**
 * @export
 */
export const UpdateUserDetailsMamaDiseaseEnum = {
    Opade: 'OPADE'
} as const;
export type UpdateUserDetailsMamaDiseaseEnum = typeof UpdateUserDetailsMamaDiseaseEnum[keyof typeof UpdateUserDetailsMamaDiseaseEnum];
/**
 * @export
 */
export const UpdateUserDetailsMamaOrganisationEnum = {
    Ailc: 'ailc',
    Dadi: 'dadi',
    Tanalentamente: 'tanalentamente',
    Dermatiteatopicadiary: 'dermatiteatopicadiary',
    MiasteniaItalia: 'miastenia-italia',
    Aendo: 'aendo',
    NoiConVoi: 'noi-con-voi',
    EndoCare: 'endo-care',
    Endometriosevereinigung: 'endometriosevereinigung'
} as const;
export type UpdateUserDetailsMamaOrganisationEnum = typeof UpdateUserDetailsMamaOrganisationEnum[keyof typeof UpdateUserDetailsMamaOrganisationEnum];
